<div class="mat-typography mat-body mat-app-background">
    <div class="dialog-close">
      <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal()">close</span>
    </div>
    <article class="content-section">
      <!-- Header -->
      <h2>
        <slot name="header">NOTICE</slot>
      </h2>

      <!-- Description -->
      <section class="description">
        <p>
          <slot name="desc">To enroll in a Catastrophic plan, please call:<br><br>{{regionPhones[data.region]}}<br><br>TTY: 711</slot>
        </p>
      </section>

      <section class="buttons">
        <button mat-raised-button color="primary" type="button" (click)="closeModal()"><span>
            <slot name="abort">Continue Shopping</slot>
          </span></button>
      </section>
    </article>
  </div>
